'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialUsd = function IoSocialUsd(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.1 23.7c0.2 0.8 0.4 1.5 0.4 2.2 0 1.7-0.4 3-1.1 4.2s-1.6 2-2.7 2.7-2.5 1.3-3.9 1.7c-0.8 0.1-1.5 0.2-2.3 0.3v2.7h-5v-2.7c-0.7-0.1-1.5-0.3-2.2-0.5-1.6-0.4-2.8-0.9-4-1.8s-2-1.9-2.7-3.2c-0.6-1.3-1-2.7-1.1-4.3h5.4c0 0.9 0.1 1.9 0.5 2.6 0.4 0.8 1 1.3 1.7 1.8s1.5 0.8 2.4 1.1v-9.4c-0.6-0.2-1.4-0.3-2.1-0.5-1.3-0.3-2.4-0.7-3.2-1.2s-1.6-1.2-2.1-1.8-0.9-1.4-1.1-2.1-0.3-1.4-0.3-2.1c0-1.4 0.3-2.7 0.9-3.8s1.5-1.9 2.6-2.6 2.3-1.3 3.6-1.6c0.5-0.2 1.2-0.2 1.7-0.3v-2.6h5v2.6c0.7 0.1 1.3 0.3 1.9 0.4 1.4 0.4 2.6 1 3.7 1.8s2 1.7 2.6 2.9c0.6 1 0.9 2.1 0.9 3.6h-5.3c-0.3-1.7-1-2.9-2.1-3.6-0.5-0.4-1-0.7-1.7-0.8v8.3c0.7 0.1 1.3 0.3 2 0.4 0.9 0.3 1.7 0.5 2.1 0.6 1 0.3 1.8 0.7 2.5 1.1 0.8 0.6 1.4 1.1 1.9 1.8s0.9 1.3 1.1 2.1z m-14.6-7.3v-7.2c-0.5 0.2-1.2 0.3-1.6 0.6-0.6 0.3-1 0.7-1.4 1.1s-0.5 1.1-0.5 1.8c0 1.1 0.3 1.9 1 2.5 0.6 0.5 1.6 0.9 2.5 1.2z m9.3 11.6c0.2-0.5 0.3-1 0.3-1.5 0-1.1-0.2-1.9-0.8-2.4s-1.1-0.9-1.8-1.1-1.2-0.4-2-0.7v8.4c0.5-0.1 0.8-0.2 1.1-0.2 0.9-0.3 1.6-0.7 2.1-1s0.9-0.9 1.1-1.5z' })
        )
    );
};

exports.default = IoSocialUsd;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-usd.js
// module id = 2716
// module chunks = 0